import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { RateCard } from "@/components/Checkout/Steps/RateSelection/RateCard/RateCard";
import { getFriendsWithBenefitsRates } from "@/components/FriendsWithBenefits/FriendsWithBenefitsRates.tsx";
import { ServiceIDs } from "@/utils/constants";
import { stripCurrencyPrefix } from "@/utils/tariffUtils";

interface Props {
  dataTestid?: string;
  tribeDiscount: number;
  /** Optional header action (e.g. order CTA on the group overview). */
  action?: ReactNode;
}

const RATE_SERVICE_IDS = [
  ServiceIDs.FlatMobileSwissMonth,
  ServiceIDs.FlatMobileMonth,
  ServiceIDs.FlatMobilePlusMonth,
] as const;

/** Display-only rate tiles matching the rate-selection product cards. */
export const WelcomeRateCards: FC<Props> = ({
  dataTestid,
  tribeDiscount,
  action,
}) => {
  const { t } = useTranslation();
  const hasDiscount = tribeDiscount > 0;
  const rates = getFriendsWithBenefitsRates({ t, tribeDiscount });

  return (
    <div data-testid={dataTestid} className="flex w-full flex-col gap-6">
      <div className="flex w-full items-start gap-3">
        <p className="min-w-0 flex-1 text-body-base font-semibold leading-md text-foreground-primary">
          {t("friendsWithBenefits.welcome.rates")}
        </p>
        {action}
      </div>

      <div className="grid gap-6 tablet:grid-cols-2 desktop:grid-cols-3">
        {rates.map((rate, index) => (
          <RateCard
            key={RATE_SERVICE_IDS[index]}
            selectionMode="display"
            product={{
              id: RATE_SERVICE_IDS[index],
              baseDisplayValue: rate.name,
              chargeFlat: hasDiscount ? rate.discountPrice : rate.price,
              minContractDur: 30,
              isVoiceProduct: true,
            }}
            originalPrice={
              hasDiscount ? stripCurrencyPrefix(rate.price) : undefined
            }
          />
        ))}
      </div>
    </div>
  );
};
